export const SuccessTick = ({ strokeColor = "white", ...props }: any) => (
  <svg width={70} height={70} fill="none" {...props}>
    <path
      fill="#23B339"
      d="M35 66.353c-17.296 0-31.354-14.058-31.354-31.354S17.704 3.645 35 3.645c17.295 0 31.354 14.058 31.354 31.354 0 17.295-14.059 31.354-31.354 31.354ZM35 8.02c-14.875 0-26.98 12.104-26.98 26.979S20.126 61.978 35 61.978s26.979-12.104 26.979-26.98c0-14.874-12.104-26.978-26.98-26.978Z"
    />
    <path
      fill="#23B339"
      d="M30.858 45.44a2.185 2.185 0 0 1-1.546-.641l-8.254-8.255a2.2 2.2 0 0 1 0-3.091 2.2 2.2 0 0 1 3.092 0l6.708 6.708L45.85 25.17a2.2 2.2 0 0 1 3.091 0 2.2 2.2 0 0 1 0 3.092L32.404 44.8a2.185 2.185 0 0 1-1.546.641Z"
    />
  </svg>
);
